module.exports = __webpack_public_path__ + "static/img/product_society_society_xczs.991455f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_xczs.svg
// module id = dcK2
// module chunks = 0